/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:56:12
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/col.js
 */
export default {
    // col 组件
    col: {
        span: 12,
        offset: 0,
        justify: 'start',
        align: 'stretch',
        textAlign: 'left'
    }
}
